export default function getIsTruthBackground(bgLink) {
  return bgLink?.startsWith?.('blob:');
}
